import React, { useState, useCallback, useContext } from 'react'
// import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import PropTypes from 'prop-types'
import { Waypoint } from 'react-waypoint';
import { motion, useViewportScroll, useTransform, useMotionTemplate } from "framer-motion"

import Container from '../global/Container'
import HTML from '../global/HTML'
import Circle from '../global/Circle'

import DisplayContext from '../../contexts/DisplayContext'

const IssuersComponent = ({ data, className }) => {

  const display = useContext(DisplayContext);

  const [elementTop, setElementTop] = useState(0);
  const { scrollY } = useViewportScroll()

  const _sectionScale = useTransform(scrollY, value => (value - elementTop) <= 1 ? 1 : 1 + ((value - elementTop) * 0.0001))

  const sectionScale = display == 'live' ? useMotionTemplate`scale(${_sectionScale})` : 'none'

  const measuredRef = useCallback(node => {
    if (node !== null) {
      setElementTop(node.getBoundingClientRect().top);
    }
  }, []);

  const [circlesPosition, setCirclesPosition] = useState('below');

  const activeCircles = {
    inside: {
      opacity: 1,
      y: 0,
    },
    above: { 
      opacity: 1,
      y: 0,
    },
  }

  const inactiveCircles = display == 'live' ? {
    below: { opacity: 0, y: 0, },
  } : {
    below: { opacity: 1, y: 0, },
  }

  const animateCircles = Object.assign(activeCircles, inactiveCircles)

  const handleCirclesPos = (currentPosition) => {
    setCirclesPosition(currentPosition)
  }

  const circlesCol = data.Circles.map((circle, index) => {
    return (
      <Circle key={index} size={320} floating={false}>
        <span>
          <HTML content={circle.text} />
        </span>
      </Circle>
    );
  });

  return (
    <div className={className} ref={measuredRef}>
      <Waypoint 
        scrollableAncestor={typeof window !== 'undefined' && window}
        onEnter={({ currentPosition }) => {
          handleCirclesPos(currentPosition)
        }}
        onLeave={({ currentPosition }) => {
          handleCirclesPos(currentPosition)
        }}
      >
        <span className="circles-intersect-ref" />
      </Waypoint>
      <span className="issuers">
        <div className="issuers-text">
          <Container>
            <h1>{data.heading}</h1>
            <div tw="text-2xl">{data.body}</div>
          </Container>
        </div>
        <motion.div className="circles"
          animate={circlesPosition}
          variants={animateCircles}
          transition={{ duration: 0.5 }}
          initial="below"
          > 
          <Container> 
            {circlesCol}
          </Container>
        </motion.div>
        
        <motion.div
          className="background"
          style={{ 
            transform: sectionScale,
            backgroundImage: `url(${
              data.background.childImageSharp
                ? data.background.childImageSharp.fluid.src
                : data.background
            })`
          }}
        />
      </span>
    </div>
  )
}

IssuersComponent.propTypes = {
  className: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
}

const Issuers = styled(IssuersComponent)`
  ${tw`overflow-hidden bg-cover relative w-full`}
  .foreground, .background {
    ${tw`overflow-hidden bg-cover absolute w-full`}
    height: 100%;
    top: 0;
    background-position: center;
  }
  .foreground { 
    z-index: 3; 
    backface-visibility: hidden;
  }
  .background { 
    z-index: 1; 
    backface-visibility: hidden;
  }
  .issuers-text {
    ${tw`w-full relative text-white`}
    z-index: 2;
    padding: 14% 0;
    @media (max-width: 639px) {
      padding-bottom: 0;
      margin-bottom: -50px;
    }
    h1 {
      font-size: 140px;
      max-width: 50%;
      line-height: 90%;
      @media (max-width: 1250px) {
        font-size: 100px;
        max-width: 70%;
      }
      @media (max-width: 767px) {
        font-size: 70px;
      }
      @media (max-width: 639px) {
        max-width: 100%;
      }
      @media (max-width: 479px) {
        font-size: 54px;
      }
    }
    > div > div {
      max-width: 500px;
      @media (max-width: 1024px) {
        max-width: 50%;
        font-size: 1.2rem;
      }
      @media (max-width: 639px) {
        max-width: 100%;
      }
    }
  }
  .circles-intersect-ref {
    position: absolute;
    z-index: 3;
    top: 50%;
    height: 1px;
  }
  .view-intersect-ref {
    position: absolute;
    z-index: 2;
    top: 100%;
    height: 1px;
  }
  .circles {
    position: absolute;
    backface-visibility: hidden;
    z-index: 5;
    font-weight: bold;
    transform: scale(1.1);
    margin-left: 55%;
    bottom: 140px;
    @media (max-width: 1250px) {
      margin-left: 55%;
      bottom: 180px;
      > div {
        transform: scale(0.8);
        transform-origin: left;
      }
    }
    @media (max-width: 1024px) {
      bottom: 100px;
      > div {
        transform: scale(0.6);
        transform-origin: left;
      }
      .circle .content {
        font-size: 1.5rem;
      }
    }
    @media (max-width: 639px) {
      position: relative;
      margin-left: 20%;
      width: 512px;
      bottom: auto;
      > div {
        transform: scale(0.6) !important;
        width: 512px;
      }
    }
    .circle {
      margin-left: -150px;
    }
    svg:nth-of-type(2) {
      margin-left: -220px;
      margin-bottom: 270px;
    }
  }
`

export default Issuers
